import React, {PureComponent} from 'react'
import {truncate} from 'lodash'
import {postItemUpdate, sendSms} from '../../api'
import Modal from "../Simple/Modal";
import Layout from "../Simple/Layout";
import CloseButton from "../Simple/CloseButton";
import AdminItemModalContent from "./AdminItemModalContent";
import Title from "../Simple/Title";
import Button from "@material-ui/core/Button/Button";
import Text from "../Simple/Text";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AdminTable from "./AdminTable";
import ApplicationModal from "../Application/ApplicationModal";


export default class AdminTableField extends PureComponent {
    state = {
        openEditFields: [],
        isEditModalVisible: false
    }

    openEditFields() {
        this.setState({openEditFields: this.props.column.alias})
    }

    closeEditField = field => {
        const openEditFields = this.state.openEditFields.filter(item => item !== field);
        this.setState({openEditFields: openEditFields})
    }


    handleUpdateSubmit = (event) => {
        event.preventDefault()
        const viewType = event.target.viewType.value
        const id = event.target.id.value
        const name = event.target.name.value
        const value = event.target.value.value
        postItemUpdate({viewType: viewType, id: id, name: name, value: value})
            .then(() => {
                this.props.item[name] = value
                this.closeEditField(name)
            })
    }

    onSendSms = (phoneNumber, userId) => {
        let content = prompt("Send message to " + phoneNumber, "");
        if (content != null && content != '') {
            sendSms(userId, content).then((response) => {
                alert(response.message)
            }).catch((response) => {
                if (response && response.message) {
                    alert(response.message)
                } else {
                    alert('Error on sending sms.')
                }
            })
        }
    }

    toggleEditModal = () => this.setState({isEditModalVisible: !this.state.isEditModalVisible})

    render() {
        const {
            item,
            column,
            viewType
        } = this.props

        const {openEditFields, isEditModalVisible} = this.state

        const modalContent = (item, column) => {
            const config = column.editModal
            return (
                <>
                    <Layout marginBottom>
                        <Title>{config.title}</Title>

                        <Text>{config.description}</Text>
                    </Layout>
                    {
                        config.items && config.items.map((configItem, configItemKey) => {
                            return (<AdminItemModalContent config={configItem} item={item} key={configItemKey}/>)
                        })
                    }
                </>
            )
        }

        return (
            <div
                 className={(column.editable && openEditFields.length === 0) ? 'edit-button-visible' : '' + (column.editable && openEditFields.length > 0) ? 'edit-form-visible' : ''}>
                {
                    column.alias.map((aliasValue, aliasIndex) => {
                            let valueLabel = truncate(item[aliasValue], {length: column.truncate ? column.truncate : 30});
                            if (column.valueLabels) {
                                valueLabel = column.valueLabels[valueLabel]
                            }

                            return ([(!column.editable || (column.editable && openEditFields.indexOf(aliasValue) === -1)) &&
                            <span
                                title={item[aliasValue] && item[aliasValue].length > (column.truncate ? column.truncate : 30) ? item[aliasValue] : null}
                                key={aliasIndex}
                                className="d-inline mr-2">{column.prefix && column.prefix}{valueLabel}{column.postfix && column.postfix}</span>,

                                (column.editable && openEditFields.indexOf(aliasValue) !== -1) &&
                                <form onSubmit={this.handleUpdateSubmit} key={aliasIndex}
                                      className="field-edit-form d-inline mr-2">
                                    <input type="hidden" name="viewType" value={viewType}/>
                                    <input type="hidden" name="id" value={item.id}/>
                                    <input type="hidden" name="name" value={aliasValue}/>
                                    {column.editType === 'textarea' && <textarea name="value" rows="8" cols="50"
                                                                                 defaultValue={item[aliasValue]}/>
                                    }
                                    {column.editType !== 'textarea' && <input type="text" name="value"
                                                                              defaultValue={item[aliasValue]}/>
                                    }
                                    <button className="btn btn-xs btn-primary btn-icon ml-1"><i
                                        className="fas fa-check"></i></button>
                                    <div className="btn btn-xs btn-icon" onClick={() => this.closeEditField(aliasValue)}><i
                                        className="fas fa-times"></i></div>
                                </form>])
                        }
                    )
                }

                {
                    (column.editable && openEditFields.length === 0) &&
                    <span className="text-primary field-edit-button cursor-pointer"
                          onClick={() => this.openEditFields()}><i
                        className="fas fa-edit"></i></span>
                }
                {column.actions && column.actions.map((actionValue, actionIndex) => {
                        if (actionValue.alias === 'sendSms') {
                            return (
                                <span key={'a-' + actionIndex} className="text-primary float-right cursor-pointer ml-1"
                                      onClick={() => this.onSendSms(item[actionValue.labelField], item[actionValue.idField])}><i
                                    className="fas fa-sms"></i></span>
                            )
                        }
                        if (actionValue.alias === 'bookingLink') {
                            return (
                                <a key={'a-' + actionIndex} className="text-primary float-right cursor-pointer ml-1"
                                   target="_blank"
                                   href={'/profile/messages/' + item[actionValue.idField]}><i
                                    className="fas fa-file-signature"></i></a>
                            )
                        }
                        if (actionValue.alias === 'boatLink') {
                            return (

                                <a key={'a-' + actionIndex} className="text-primary float-right cursor-pointer ml-1"
                                   target="_blank"
                                   href={'/profile/boat/' + item[actionValue.idField]}><i className="fas fa-ship"></i></a>
                            )
                        }
                        if (actionValue.alias === 'sendEmail') {
                            return (
                                <a key={'a-' + actionIndex} className="text-primary float-right cursor-pointer ml-1"
                                   href={'mailto:' + item[actionValue.labelField]} target="_blank"><i
                                    className="fas fa-envelope"></i></a>
                            )
                        }
                        if (actionValue.alias === 'editModal') {
                            return (
                                <div style={{margin: '-2px -10px 2px -15px', display: 'inline-block'}}>
                                    {false && <><Button variant="flat" size="small" onClick={this.toggleEditModal}
                                                        className={'decide-btn btn-color-success'}
                                                        key={'b2-' + actionIndex}>
                                        <FontAwesomeIcon size="lg" icon={['fal', 'check']}/>
                                    </Button>
                                        <Button variant="flat" size="small" className={'decide-btn btn-color-danger'}
                                                onClick={this.toggleEditModal} key={'b3-' + actionIndex}>
                                            <FontAwesomeIcon size="lg" icon={['fal', 'times']}/>
                                        </Button></>}
                                    <Button variant="flat" size="small" color="primary" onClick={this.toggleEditModal}
                                            key={'b1-' + actionIndex}>
                                        <FontAwesomeIcon size="lg" icon={['fal', 'file-signature']}/>
                                    </Button>
                                    {false && <span key={'a-' + actionIndex} className="text-primary btn btn-link"
                                                    style={{padding: 0, lineHeight: 0, fontSize: 18}}
                                                    onClick={this.toggleEditModal}><i
                                        className="fas fa-ellipsis-h"></i></span>}

                                    {isEditModalVisible && false &&
                                    <ApplicationModal toggle={this.toggleEditModal}></ApplicationModal>}
                                    {isEditModalVisible && false &&
                                    <Modal onOutsideAction={this.toggleEditModal} key="modal" style={{overflow: 'auto'}}>
                                        <Layout padding className="admin-modal">
                                            <CloseButton onClick={this.toggleEditModal}/>
                                            <Layout marginTop>{modalContent(item, column)}</Layout>
                                        </Layout>
                                    </Modal>}
                                </div>

                            )
                        }
                    }
                )
                }
            </div>
        )
    }
}
